import { HIDE_REWARD_CLAIM_SECTION } from "utils/Config";
import { isInsideShopify } from "utils/UIConfigUtils";

export const getInboxUnreadCount = (messageUnreadCount) => {
  if (messageUnreadCount > 99) {
    return ' (99+)';
  }
  if (messageUnreadCount <= 0) {
    return '';
  }
  return ` (${messageUnreadCount})`;
};

const homeAndOffer = [
  {
    name: "home_home",
    linkTo: "/home",
    imageUrl: '/menu/home.svg',
  },
  {
    name: "home_offers",
    linkTo: "/offer/LATEST",
    imageUrl: '/menu/offer.svg',
  },
]

const aboutPage = {
  name: "about_upper",
  linkTo: "/about",
  imageUrl: '/menu/about.svg',
}

const rewardClaimPage = {
  name: "points_claim",
  linkTo: "/transaction",
  imageUrl: '/menu/cart.svg',
}

const inboxPage = {
  name: "home_inbox",
  linkTo: "/inbox",
  imageUrl: '/menu/Inbox.svg',
}

const getLoginNavItems = ()=> {
  const items = [...homeAndOffer]
  const insideShopify = isInsideShopify();
  if (!HIDE_REWARD_CLAIM_SECTION && !insideShopify) {
    items.push(rewardClaimPage)
  }
  if (!insideShopify) {
    items.push(aboutPage)
  }
  items.push(inboxPage)
  return items
}

export const unloginCommonNavItemList = [...homeAndOffer, aboutPage]

export const loginCommonNavItemList = getLoginNavItems()


export const profileNavItemList = [
  {
    name: 'my_profile',
    linkTo: '/user/myProfile',
    imageUrl: '/menu/myProfile.svg',
  },
  {
    name: 'my_card',
    linkTo: '/user/myCard',
    imageUrl: '/menu/myCard.svg',
  },
  {
    name: 'profile_my_coupons',
    linkTo: '/user/myCoupon',
    imageUrl: '/menu/myCoupons.svg',
  },
  {
    name: 'myTicket',
    linkTo: '/user/myTicket',
    imageUrl: '/menu/myCoupons.svg',
  },
  {
    name: 'profile_my_account',
    linkTo: '/user/myAccount',
    imageUrl: '/menu/myAccount.svg',
  },
];
